import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import { Spinner } from '../components/ui/Spinner'

// RequireAuth gates a subtree on a signed-in user. While Firebase is
// restoring the session from IndexedDB it shows a centered spinner —
// kicking the user back to /login during that brief window flickers on
// every page refresh.
export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spinner />
      </div>
    )
  }
  if (!user) {
    // Preserve the FULL original destination — path + query + hash — so Login
    // can bounce the user back exactly where they intended to go after a
    // successful signin (F2). Dropping search/hash here would land a
    // deep-linked URL (e.g. a glow tab ?tab=versions) on the bare path.
    const from = location.pathname + location.search + location.hash
    return <Navigate to="/login" replace state={{ from }} />
  }
  return <>{children}</>
}
